module.exports = __webpack_public_path__ + "static/img/welcome-img-2.7d6ff50.png";